var lgpdMenuItem = ".lgpd-menu--item";
var lgpdMenuContent = ".lgpd-section-menu--content";
var lgpdIcons = ".lgpd--section-icon";

$(document).ready(function () {
  if ($("#lgpd").length) {
    initLgpdPage();
  }
});

function initLgpdPage() {
  $(lgpdMenuItem).click(function () {
    if ($(this).hasClass("ativo")) return;

    $(lgpdMenuItem).each(function () {
      $(this).removeClass("ativo");
    });

    $(lgpdMenuContent).each(function () {
      $(this).removeClass("ativo");
    });

    $(this).addClass("ativo");
    $($(this).data("target")).addClass("ativo");

    if ($(this).data("redir")) {
      var rtarget = $(this).data("target");

      $(lgpdMenuItem).each(function () {
        if ($(this).data("target") == rtarget && !$(this).data("redir"))
          $(this).addClass("ativo");
      });
    }

    if ($(this).data("icon")) {
      $(lgpdIcons).each(function () {
        $(this).addClass("hidden");
      });

      $($(this).data("icon")).removeClass("hidden");
    }
  });
}
